module.exports = __webpack_public_path__ + "img/next.c87245f7.png";